import { nanoid } from 'nanoid'

; (function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('InputDropdownController', InputDropdownController)

  /* @ngInject */
  function InputDropdownController ($scope, $attrs, $timeout, $translate, UdsModalService, Utils) {
    const getUpgradeCompanyPlanDialogController = () => import('../../../core/dialogs/upgrade-company-plan/upgrade-company-plan-dialog.controller')

    $scope.pagination = {
      shouldLoadMore: true,
      loading: false,
      itemsIndex: 0
    }
    $scope.hideDropdownIcon = false
    $scope.id = nanoid()

    const api = {
      _handleOnChangeDropdownValue,
      _addInfiniteScrollToDropdown,
      _selectValue,
      _skipPagingTo,
      _onResponse,
      _openUpgradeCompanyPlanDialog,
      getUpgradeCompanyPlanDialogController,
      _handleInputWidth,
      _checkForLinks
    }
    this.getApi = () => api

    activate()

    function activate () {
      const dropdownOptions = {
        onChange: api._handleOnChangeDropdownValue,
        message: {
          noResults: $translate.instant('noResults')
        }
      }
      if ($scope.clearable === true || $scope.clearable === false) {
        dropdownOptions.clearable = $scope.clearable
      }
      if ($scope.fullSearch === true || $scope.fullSearch === 'exact') {
        dropdownOptions.fullTextSearch = $scope.fullSearch
      }
      if ($scope.direction) {
        dropdownOptions.direction = $scope.direction
      }

      if ($scope.externalSearchUrl && $scope.apiResponseFn) {
        dropdownOptions.apiSettings = {
          url: $scope.externalSearchUrl,
          onResponse: api._onResponse,
          cache: false
        }
      }

      api._handleInputWidth()
      api._checkForLinks()

      $timeout(() => {
        $attrs.$$element.find('.input-dropdown').dropdown(dropdownOptions)
        jQuery('.input-dropdown-tooltip').popup()
      }, 100, false)

      $timeout(() => {
        api._addInfiniteScrollToDropdown()
      }, 1000, false)
    }

    const deregisterInputDropdownChange = $scope.$on('input-dropdown.change', () => {
      api._selectValue()
    })

    $scope.$on('$destroy', () => {
      deregisterInputDropdownChange()
    })

    $scope.$watch('value', api._selectValue)

    $scope.handleInputClick = () => {
      if ($scope.pricing) {
        api._openUpgradeCompanyPlanDialog($scope.pricingData)
      }
      if ($scope.onClick) {
        $scope.onClick()
      }
    }

    $scope.onLastRepeatDropdownOption = () => {
      api._selectValue()
    }

    function _openUpgradeCompanyPlanDialog (pricingData) {
      api.getUpgradeCompanyPlanDialogController().then(({ UpgradeCompanyPlanDialogController }) => {
        const upgradeCompanyPlanDialog = UdsModalService.createModal({
          controller: UpgradeCompanyPlanDialogController,
          modalName: 'upgradeCompanyPlanDialog',
          data: pricingData
        })
        upgradeCompanyPlanDialog.open()
      })
    }

    function _handleInputWidth () {
      const input = $attrs.$$element.find('.input-dropdown')[0]
      if (input?.offsetWidth < 210) {
        $timeout(() => {
          $scope.hideDropdownIcon = true
        }, 0, true)
      }
    }

    function _onResponse (res) {
      $scope.apiResponseFn(res)
        .then(() => {
          $scope.pagination.itemsIndex = 0
          api._addInfiniteScrollToDropdown()
        })
    }

    function _selectValue () {
      if ($scope.value) {
        $timeout(() => {
          $attrs.$$element.find('.input-dropdown').dropdown('set selected', $scope.value)
        }, 1000, false)
      }
    }

    function _handleOnChangeDropdownValue (value, text) {
      const propertyName = $scope.modelPropertyName
      if ($scope.change) {
        $scope.change({
          modelPropertyName: propertyName,
          modelNewValue: value
        })
      } else if (typeof $scope.model === 'object' && propertyName) {
        $scope.model[propertyName] = value
      } else if ($scope.multiple) {
        let splitArray = value.split(',')
        if (splitArray.length === 1 && !splitArray[0]) {
          splitArray = []
        }
        $scope.model = splitArray
      } else {
        $scope.model = value
      }
      if (!$scope.$$phase) $scope.$apply()

      if ($scope.event) {
        $scope.$emit($scope.event, value)
      }
    }

    function _skipPagingTo (index) {
      if (!$scope.enablePagination || !$scope.paginationFn) {
        return
      }

      $scope.pagination.shouldLoadMore = false
      $scope.pagination.loading = true
      $scope.paginationFn(index, $scope.pagination)
    }

    function _addInfiniteScrollToDropdown () {
      if (!$scope.enablePagination || !$scope.paginationFn) {
        return
      }

      const menu = $attrs.$$element.find('.input-dropdown').find('.menu')

      if (menu.length) {
        menu.scroll(function () {
          if ($scope.pagination.shouldLoadMore && $scope.options.length < $scope.optionsCount && menu.scrollTop() + menu.innerHeight() >= menu[0].scrollHeight - 1) {
            $scope.pagination.itemsIndex += 1
            api._skipPagingTo($scope.pagination.itemsIndex)
          }
        })
      }
    }

    function _checkForLinks () {
      const result = Utils.processTextsWithLinks([$scope.label, $scope.description])
      $scope.labelWithLinks = result[0]
      $scope.descriptionWithLinks = result[1]
    }
  }
})()
